
  import ipxRuntime$X0mVYgftBdDJPg5f_45QLGJ0a2zjLYutV7r5OV5Ma74sE from '/builds/skuby/fashion-shop-template/projects/web/node_modules/.bun/@nuxt+image@2.0.0+4f84fc6d29f7a7fb/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import skubyApiRuntime$_4DskMealDAEthIFevK4p0z99gF6yQEEDlSZ87gbRu4s from '/builds/skuby/fashion-shop-template/projects/web/apps/web/config/image/ApiImageProvider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "api.skuby.dev.alt-point.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$X0mVYgftBdDJPg5f_45QLGJ0a2zjLYutV7r5OV5Ma74sE, defaults: {"maxAge":604800} },
  ['skubyApi']: { setup: skubyApiRuntime$_4DskMealDAEthIFevK4p0z99gF6yQEEDlSZ87gbRu4s, defaults: undefined }
    }
  }
